<template>
<div>
  <div class="small-card-warpper" v-if="this.options" v-bind:style="{background: background}">
    <div class="left-part">
      <h2>{{value}} <span>{{options.unit}}</span></h2>
      <h4>{{options.header || ""}} </h4>
    </div>
    <div class="right-part">
      <h5 class="dyamic-footer">{{options.dyamicFooter }}</h5>
      <h5 class="footer">{{options.footer || ""}}</h5>
    </div>
  </div>
  <div v-else>
    pls bind "options" or contact developer
    请绑定“选项”或联系开发人员
  </div>
</div>
</template>

<script>
export default {
  name: 'ColorfulCard',
  props: ['options'],
  data () {
    return {
      background: '#66ccff'
    }
  },
  mounted () {
    if (this.options.leftColor && this.options.rightColor) {
      this.background = `linear-gradient(to right, ${this.options.leftColor}, ${this.options.rightColor})`
    }
  },
  computed: {
    value () {
      if (this.options && this.options.formatter) {
        return this.options.formatter(this.options.value)
      } else if (this.options) {
        return this.options.value
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.small-card-warpper {
  min-height: 90px;
  min-width: 220px;
  border-radius: 3px;
  position: relative;
  padding: 10px;
  // background-color: #66ccff;
  .left-part {
    h2, h4 {
      margin: 0;
      padding: 0;
      color: #fff;
    }
    h2 span {
      font-size: 16px;
    }
  }
  .right-part {
    text-align: end;
    h5 {
      margin: 0;
      padding: 0;
      color: #fff;
    }
  }
}
</style>
